import React, { useMemo } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import FlowsIndexPage from './pages/FlowsIndexPage';
import FlowDetailPage from './pages/FlowDetailPage';
import TemplatesTab from './tabs/TemplatesTab';
import CheckpointsTab from './tabs/CheckpointsTab';

export default function OpsPage(): React.ReactElement {
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab2 =
    location.pathname.includes('/app/admin/ops/templates')
      ? 'templates'
      : location.pathname.includes('/app/admin/ops/checkpoints')
        ? 'checkpoints'
        : 'flows';

  const tabs = useMemo(
    () => [
      { id: 'flows' as const, label: 'Flows' },
      { id: 'templates' as const, label: 'Templates' },
      { id: 'checkpoints' as const, label: 'Checkpoints' },
    ],
    []
  );

  return (
    <div className="admin-panel admin-panel-fullscreen" data-active-tab="ops">
      <div className="admin-ribbon">
        <button className="admin-back-btn" onClick={() => navigate('/app/admin')} title="Back to Admin">
          ← Back
        </button>
        <div className="admin-tabs-ribbon">
          {tabs.map((t) => (
            <button
              key={t.id}
              onClick={() => {
                if (t.id === 'flows') navigate('/app/admin/ops/flows');
                else if (t.id === 'templates') navigate('/app/admin/ops/templates');
                else navigate('/app/admin/ops/checkpoints');
              }}
              className={`tab-button ${activeTab2 === t.id ? 'active' : ''}`}
            >
              <span className="tab-label">{t.label}</span>
            </button>
          ))}
        </div>
        <h1 className="admin-ribbon-title">Ops</h1>
      </div>

      <div className="admin-content">
        <Routes>
          <Route path="/" element={<Navigate to="flows" replace />} />
          <Route path="flows" element={<FlowsIndexPage />} />
          <Route path="flows/:flowId" element={<FlowDetailPage />} />
          <Route path="templates" element={<TemplatesTab />} />
          <Route path="checkpoints" element={<CheckpointsTab />} />
        </Routes>
      </div>
    </div>
  );
}

